<ticker-card
  titleText="Revenue Total"
  [data]="data"
  [percentage]="-14.7"
  icon="dataarea"
></ticker-card>
